<template>
	<div class="focusenterprises" >
		<leftnav class="fl" :title="notionname+'-当地图谱查看更多相关企业'"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage targetenterlist ">
				<div class="whitebox right_topbox targetenterlist-title">
					<div class="w95mg"> 
						<h5 class="title1 fl">{{calCuData.text}}当地图谱节点<span class="orange_font">{{notionname}}</span>查看更多相关企业</h5>
					<!-- 	<span class="fr curp" >返回原图谱详情页</span> -->
						<!-- <span class="notionname fl">{{calCuData.text}}</span> -->
					 <!-- <span class="notionname fl"> {{notionname}}</span> -->
					</div>
				</div> 
				<!-- 企业列表 -->
				<div class="usermg usercl_box whitebox screenHeight">
					<div class="enterparise_guide oh w95mg sp">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>   
					</div>
				<!-- 	<ul class="user_tabtitle w95mg" >
						<li v-for="(item,i) in tabtitle" :class="type==item.type?'current':''"	@click="tabbtnfun(item,i)">{{item.name}}</li> 
					</ul> -->
					<!-- 龙头  优质 上市 创新通用表格 -->
					<div class="collect_bigEns w95mg">
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr> 
							<tr v-for="(list,index) in entercommlist">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.notionlist" @click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" v-for="item in list.taglist" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table> 
					</div> 
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div> 
				<!--  -->
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'localChainMoreEnterprise', 
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title:"目标招商企业",total1:1,notionlist:[],calCuData:{},
				userdata: {},pagetype:1,notioncode:0,notionname:'',tabindex:0,type:0,tabtogglebtn:true,choosecity:false,
				selectcitydata:[], citymapdata:[], cityflag:false,citylistbtn:false,showmorecitydata:false, 
				cityid:0,provinceid:0,mapcityBtn:false,choosecitydata:[],
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
				tabtitle: [
					// {curindex: 1,type: 9,name: "上市公司",tabindex:0,},
					// {curindex: 2,type: 1,name: "龙头企业",tabindex:1,},
					// {curindex: 3,type: 2,name: "创新企业",tabindex:2}, 
					// {curindex: 4,type: 3,name: "优质企业",tabindex:3},  
					{curindex: 5,type: 0,name: "全部企业",tabindex:4},  
				],  
				dimesmlist:[{name: '总体评分',type: 0}, {name: '企业实力',type: 2	}, {name: '投资力度',type: 3},],
				// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},{name:'营业收入（亿元）',type:12},{name:'营收增速',type:13},{name:'净利润（亿元）',type:14},{name:'净利增速',type:15},
				tabbtn: 1, 
				entercommlist:[],   
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
			}
		},
		created() {
			this.notionname=this.$route.query.keyword; 
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
		},
		mounted() { 
			this.userdata = this.getuseriformation();
			this.notioncode=this.$route.query.id;
			this.type=this.$route.query.type?this.$route.query.type:0; 
			this.calCuData=this.getCalcuCity(this.userdata);
			this.bus.$emit('loading', true); 
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
			this.getlist();
			// this.getcollectlist(2);
			// this.getcollectlist(3);
			// this.getcollectlist(4);
		},
		methods: { 
			//地图点击事件
			choosecityide(art){
				// console.log(art); 
				this.choosecityid(art[0],art[1]);
			},
		 
			 
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getlist();
				// this.ajaxsearchcompany();
			},
			pageHandler: function(page) {
				this.page = page;
				this.getlist();
			},
			//获取产业链收藏列表
			getlist() {
				// this.bus.$emit('loading',true);
				var _this = this; 
				var provinceidja =this.splicing('province',this.userdata.province);
				var cityJa =this.splicing('city',this.userdata.city);
				// var cityidja =this.splicing('city',this.cityid); 
				var ajaxurl = this.$api.cyl.enterprise.list() + '?calCity=0&resultType=0&search=0&type=0' + provinceidja+cityJa + '&page='+this.page+'&orderField='+this.orderField+'&orderType='+this.orderType+'&notion='+this.notioncode;
				this.$axios.get(ajaxurl, {
					headers: {AuthToken: this.userdata.token}
				}).then(function(res) { 
					console.log(ajaxurl,res.data)
					if (res.data.success) {
						// var enterlist = res.data.list;  
						var dataenterlist= res.data.list;
					
						for (var i = 0; i < res.data.list.length; i++) { 
							dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode,'notionsort');
							dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);  
						} 
							_this.entercommlist=dataenterlist; 
							// _this.total1=res.data.totalRecord;  
						//分页数据
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize; 
						_this.bus.$emit('loading',false); 
					} else {
						
					}
				}).catch(function(error) {
					// console.log('错误',error);//请求失败处理 
				}); 
			},
			//加入、移除目标企业
			collectToggle(list){
				var _this=this,cid=list.collectId;
				var ajaxurl="",ajaxdata={};
				if(cid == 0){
				 ajaxurl=this.$api.cyl.collect.add();
					ajaxdata={type:list.collectType,id:list.stockCode}
					}else{
						ajaxurl=this.$api.cyl.collect.remove();
						ajaxdata={collectId:list.collectId};
					}
					$.ajax({
						type:"POST",
						url:ajaxurl,
						data:ajaxdata,
						headers:{AuthToken:this.userdata.token },
						success:function(res){ 
							// console.log('1123',res);
							if(res.success){
								if(cid == 0){
									list.collectId=res.data.collectId;
								}else{
									list.collectId=0;
								} 
							} 
						} 
					}) 
			}
		 
		},
	}
</script> 
